import { RadioGroup, RadioGroupProps } from "@chakra-ui/react";
import { useController } from "react-hook-form";
import { usePrefixedFieldName } from "shared/components/form/FormFieldPrefix";
import { FormErrorTooltip } from "shared/components/tooltip/ErrorTooltip";

export interface FormRadioGroupProps
  extends Omit<RadioGroupProps, "value" | "onChange"> {
  name: string;
}

export const FormRadioGroup: React.FC<
  React.PropsWithChildren<FormRadioGroupProps>
> = ({ name, ...otherProps }) => {
  const prefixedName = usePrefixedFieldName(name);
  const { field } = useController({
    name: prefixedName,
    shouldUnregister: true,
  });
  return (
    <FormErrorTooltip name={name}>
      <RadioGroup
        value={field.value as string}
        onChange={field.onChange}
        {...otherProps}
      />
    </FormErrorTooltip>
  );
};
